import { languageMap } from ".."

languageMap.vbnet = {
	comments: {
		line: "'",
	},
}
